import { CREATIVE_AI_ROUTE } from './routes'

/** Composed into module 08's Creative Performance group by the shell (`registerShellNavigation`). */
export const creativeAiNavItems = [
  {
    labelKey: 'creativeAi.page.title',
    navKey: 'creativeAi',
    to: CREATIVE_AI_ROUTE,
    visibility: { control: 'flag' as const, id: 'Creative-AI' },
  },
]
